import { Footer as FlowbiteFooter } from 'flowbite-react';

export default function Footer() {
  return (
    <FlowbiteFooter container>
      <div className="w-full text-center">
        <span>
          Made with ❤️ by
          <a
            className="underline ml-2"
            href="https://koana-labs.com"
            target="_blank"
            rel="noreferrer"
            title="Koana Labs"
          >
            Koana Labs
          </a>
        </span>
      </div>
    </FlowbiteFooter>
  );
}
